export const getEmployeeProfileRequestSchema = {
  title: "Request Employee Profile",
  logicalname: "EmployeeProfileRequest",
  type: "object",
  properties: {
    name: {
      title: "Name",
      type: "string",
      schemaname: "name",
      datatype: "string",
      requiredCheck: true,
      pattern: "^[^ ].{1,}$",
      message: "Name must be at least 2 characters and cannot start with a space",
    },
    email: {
      title: "Email",
      type: "string",
      schemaname: "email",
      datatype: "string",
      requiredCheck: true,
      pattern: "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$",
      message: "Please enter a valid email address",
    },
    employer: {
      title: "Employer/Company Name",
      type: "string",
      schemaname: "employer",
      datatype: "string",
      requiredCheck: false,
    },
    reasonForContacting: {
      title: "Reason for Contacting",
      type: "string",
      schemaname: "reasonForContacting",
      datatype: "string",
      ismultiline: true,
      multilineRow: 5,
      requiredCheck: false,
    },
  },
};

